<template>
  <nav class="activity-tabs">
    <ul class="activity-tabs-list">
      <li
        v-for="genre in activityGenre"
        :ref="genre.value"
        :key="genre.value"
        :id = "setTagId(genre.value)"
        @click="onClick(genre.value)"
        @mouseover="onMouseOver(genre.value)"
        @mouseleave="onMouseLeave(genre.value)"
        :class="['activity-tabs-list-item', { 'active': currentGenre === genre.value }]"
        :style="[currentGenre === genre.value ? activeColorObject : nonActiveColorObject]"
      >
        {{ genre.text }}
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    textColor: {
      type: String,
      default: 'rgb(0, 0, 0)'
    }
  },
  data () {
    return {
      activityGenre: [
        {
          text: 'All',
          value: 'all'
        },
        {
          text: 'Event',
          value: 'event'
        },
        {
          text: 'News',
          value: 'message'
        },
        {
          text: 'Member',
          value: 'member'
        },
        {
          text: 'Twitter',
          value: 'twitter'
        },
        {
          text: 'Music',
          value: 'music'
        },
        {
          text: 'Movie',
          value: 'movie'
        }
      ],
      activeColorObject: {
        color: this.textColor,
        borderBottom: '3px solid ' + this.textColor
      },
      nonActiveColorObject: {
        color: this.textColor,
        borderBottom: '3px solid ' + this.textColor.slice(0, -1) + ' ,.2' + this.textColor.slice(-1, this.textColor.length)
      }
    }
  },
  computed: {
    currentGenre: function () {
      return this.$store.getters['performer/currentGenre']
    }
  },
  methods: {
    onClick: function (genre) {
      this.$emit('updateGenre', genre)
    },
    onMouseOver: function (ref) {
      this.$refs[ref][0].style.borderBottom = '3px solid ' + this.textColor
    },
    onMouseLeave: function (ref) {
      if (this.currentGenre === ref) return
      this.$refs[ref][0].style.borderBottom = '3px solid ' + this.textColor.slice(0, -1) + ' ,.2' + this.textColor.slice(-1, this.textColor.length)
    },
    setTagId: function (genre) {
      return "tag-" + genre;
    },
  }
}
</script>

<style lang="scss" scoped>
$breakpoint: 767px;

  .activity-tabs {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    display: flex;

    @media screen and (max-width: $breakpoint) {
      padding: 0 20px;
    }

    &-list {
      display: flex;

      &-item {
        cursor: pointer;
        text-align: center;
        flex-basis: 80px;
        flex-shrink: 0;
        padding-bottom: 15px;
        opacity: 0.3;
        transition: .2s;

        &.active,
        &:hover {
          opacity: 1;
        }
      }
    }
  }
</style>
